// Roho Living homepage interactions: parallax on hero bottle + reveal-on-scroll for cards.
// Loaded only on the homepage from layout/theme.liquid.

(function () {
  // Gentle parallax on hero bottle.
  var bottle = document.querySelector('.roho-hero__bottle');
  if (bottle) {
    window.addEventListener(
      'scroll',
      function () {
        var y = window.scrollY;
        if (y < 800) {
          bottle.style.transform = 'translateY(' + y * 0.15 + 'px)';
        }
      },
      { passive: true }
    );
  }

  // Reveal on scroll for cards across sections.
  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  var selector = [
    '.roho-bestsellers__card',
    '.roho-intentions__card',
    '.roho-collections__card',
    '.roho-reviews__card',
    '.roho-standards__card',
  ].join(', ');

  document.querySelectorAll(selector).forEach(function (el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
    observer.observe(el);
  });
})();
